import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaInfoCircle } from "react-icons/fa";
import redirectURL from "../redirectURL";
import "./datepicker.css"

const todayIST = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const PmAggregatedInventory = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [highlightedDates, setHighlightedDates] = useState([]);


  // Slider state for Trigger
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [triggerDate, setTriggerDate] = useState(() => todayIST());
  const [isTriggering, setIsTriggering] = useState(false);

  const [currentDate, setCurrentDate] = useState("");
  const [isDateTriggered, setIsDateTriggered] = useState(false);
  const [isRevoking, setIsRevoking] = useState(false);

    const isSameYMD = (d1, d2) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    useEffect(() => {
      if (!triggerDate || !highlightedDates || highlightedDates.length === 0) {
        setIsDateTriggered(false);
        return;
      }

      const selected = new Date(triggerDate);
      const found = highlightedDates.some((d) => isSameYMD(d, selected));
      setIsDateTriggered(found);
    }, [triggerDate, highlightedDates]);

  // CustomHeader component
  const CustomHeader = (props) => {
    const tooltip = props?.column?.getColDef()?.headerTooltip || "";
    const [showMenu, setShowMenu] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onMenuClick = (event) => {
      props.showColumnMenu(event.currentTarget);
    };

    const onSortRequested = (order, event) => {
      props.setSort(order, event?.shiftKey);
    };

    const getSort = () => {
      return props.column.getSort();
    };

    const isSortable = props.column.getColDef().sortable;

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
        onMouseEnter={() => setShowMenu(true)}
        onMouseLeave={() => setShowMenu(false)}
      >
        <span
          style={{
            cursor: isSortable ? "pointer" : "default",
            userSelect: "none"
          }}
          onClick={isSortable ? () => {
            const currentSort = getSort();
            let newSort = 'asc';
            if (currentSort === 'asc') newSort = 'desc';
            else if (currentSort === 'desc') newSort = null;
            onSortRequested(newSort, null);
          } : undefined}
        >
          {props.displayName}
        </span>

        {isSortable && (
          <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'asc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('asc', null)}
            >
              ↑
            </span>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'desc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('desc', null)}
            >
              ↓
            </span>
          </div>
        )}

        <div
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

          {showTooltip && tooltip && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                zIndex: 1000,
                marginTop: "5px",
              }}
            >
              {tooltip}
            </div>
          )}
        </div>

        {props.enableMenu && (
          <span
            onClick={onMenuClick}
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              fontSize: 14,
              opacity: showMenu ? 1 : 0,
              transition: "opacity 0.2s ease",
            }}
          >
            ☰
          </span>
        )}
      </div>
    );
  };

const columnDefs = [
  { headerName: "Date", field: "date", hide: true },
  { headerName: "FG SKU Code", field: "fg_sku_code" },
  { headerName: "FG Category", field: "fg_category" },
  { headerName: "FG SKU Name", field: "fg_sku_name" },
  { headerName: "FG SKU Category", field: "fg_sku_category" },
  { headerName: "PM SKU Code", field: "pm_sku_code" },
  { headerName: "PM SKU Name", field: "pm_sku_name" },
  { headerName: "PM Type", field: "pm_type" },
  { headerName: "PM Category", field: "pm_category" },

  { headerName: "Bhiwandi Bad Bin", field: "bhiwandi_bad_bin" },
  { headerName: "Bhiwandi QC Hold", field: "bhiwandi_qc_hold" },
  { headerName: "Bhiwandi Old Version", field: "bhiwandi_old_version" },
  { headerName: "Bhiwandi Current Version", field: "bhiwandi_current_version" },

  { headerName: "Gurgaon Current Version", field: "gurgaon_current_version" },
  { headerName: "Bangalore Current Version", field: "bangalore_current_version" },

  { headerName: "BK Bad Bin", field: "bk_bad_bin" },
  { headerName: "BK Current Version", field: "bk_current_version" },
  { headerName: "BK QC Hold", field: "bk_qc_hold" },

  { headerName: "BBK Bad Bin", field: "bbk_bad_bin" },
  { headerName: "BBK Current Version", field: "bbk_current_version" },
  { headerName: "BBK QC Hold", field: "bbk_qc_hold" },

  { headerName: "3P Christy Current Version", field: "3p_christy_current_version" },
  { headerName: "3P Elvita Current Version", field: "3p_elvita_current_version" },
  { headerName: "3P Fermentis Current Version", field: "3p_fermentis_current_version" },
  { headerName: "3P RaghuLeela Current Version", field: "3p_raghuleela_current_version" },
  { headerName: "3P Ruparel Current Version", field: "3p_ruparel_current_version" },
  { headerName: "3P Vark Current Version", field: "3p_vark_current_version" },

  { headerName: "BK Old Version", field: "bk_old_version", hide: true },
  { headerName: "BBK Old Version", field: "bbk_old_version", hide: true },
  { headerName: "3P Christy Bad Bin", field: "3p_christy_bad_bin", hide: true },
  { headerName: "3P Elvita Bad Bin", field: "3p_elvita_bad_bin", hide: true },
  { headerName: "3P Fermentis Bad Bin", field: "3p_fermentis_bad_bin", hide: true },
  { headerName: "3P RaghuLeela Bad Bin", field: "3p_raghuleela_bad_bin", hide: true },
  { headerName: "3P Ruparel Bad Bin", field: "3p_ruparel_bad_bin", hide: true },
  { headerName: "3P Vark Bad Bin", field: "3p_vark_bad_bin", hide: true },

  { headerName: "3P Christy Old Version", field: "3p_christy_old_version", hide: true },
  { headerName: "3P Christy QC Hold", field: "3p_christy_qc_hold", hide: true },
  { headerName: "3P Elvita QC Hold", field: "3p_elvita_qc_hold", hide: true },
  { headerName: "3P Fermentis QC Hold", field: "3p_fermentis_qc_hold", hide: true },
  { headerName: "3P RaghuLeela QC Hold", field: "3p_raghuleela_qc_hold", hide: true },
  { headerName: "3P Ruparel QC Hold", field: "3p_ruparel_qc_hold", hide: true },
  { headerName: "3P Vark QC Hold", field: "3p_vark_qc_hold", hide: true },
];


  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  }

  const getAggregatedData = async () => {
    try {
      const response = await redirectURL.post("inventory/getAggregatedPMData", {});

      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const { date, data } = response.data;

          const formattedDate = date ? new Date(date).toISOString().split('T')[0] : '';

          setRowData(data);
          setCurrentDate(formattedDate);
          await getHighlightedDates();
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setBasicTitle("No PM  Inventory data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch data");
      setBasicType("error");
      setShow(true);
    }
  }
   const getHighlightedDates = async () => {
  try {
    const response = await redirectURL.post("inventory/getPMAMaterialAvailableDates", {});
    if (response.status === 200 && response.data.dates) {
      const dates = response.data.dates.map(dateStr => {
        try {
          return new Date(dateStr);
        } catch (e) {
          return null;
        }
      }).filter(date => date !== null);
      setHighlightedDates(dates);
    }
  } catch (error) {
    console.error("Failed to fetch highlighted dates:", error);
  }
}


    const onRevokeTrigger = async (e) => {
  e.preventDefault();

  if (!triggerDate) {
    setShow(true);
    setBasicType("info");
    setBasicTitle("Please select a date");
    return;
  }

  try {
    setIsRevoking(true);
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const response = await redirectURL.post(
      "inventory/onRevokePMAggregatedInventory",
      { trigger_date: triggerDate }
    );

    const res = response?.data?.pyResponse || response?.data;

    if (res?.status === "Success") {
      setShow(true);
      setBasicType("success");
      setBasicTitle(res.message || "Revoked successfully");

      setSliderOpen(false);
      setOverlyBlock("show-n");
      setTriggerDate(todayIST());

      // Refresh data immediately
      await getMainData();
      await getHighlightedDates();
      
      // Also refresh grid data based on current filter (if any)
      if (currentDate) {
        await getAggregatedDataByFilter();
      }

      // Optional audit
      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Revoke PM Inventory",
        status: res.status,
        path: window.location.pathname
      });
    } else {
      setShow(true);
      setBasicType("info");
      setBasicTitle(res?.message || "Failed to revoke");
    }
  } catch (error) {
    setShow(true);
    setBasicType("error");
    setBasicTitle(
      error?.response?.data?.message || "Failed to revoke. Please try again later."
    );
  } finally {
    setIsRevoking(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }
};
  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getAggregatedData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  }

  const getAggregatedDataByFilter = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {};

    if (currentDate) {
      params.date = currentDate;
    }

    try {
      const response = await redirectURL.post(
        "inventory/getAggregatedPMDataByFilter",
        params
      );
      const data = response.data.data;
      setRowData(data);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Error Failed to get PM  Inventory Data");
    }
  };

  const setFilters = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getAggregatedDataByFilter();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const resetFilters = async () => {
    setCurrentDate("");
    await getMainData();
  }

  useEffect(() => {
    getMainData();
  }, []);

  const closeAlert = () => {
    setShow(false);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    setTriggerDate(todayIST());
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setTriggerDate(todayIST());
  };

  const openTriggerSlider = () => {
    setSliderType(1);
    setSliderTitle("Trigger PM  Inventory");
    setSliderCl("trigger-pm--slider");
    setOverlyBlock("show-m");
    setSliderOpen(true);
  };

  const onSaveTrigger = async (e) => {
    e.preventDefault();
    if (!triggerDate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please select a date");
      return;
    }

    try {
      setIsTriggering(true);
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post(
        "inventory/onTriggerPMAggregatedInventory",
        { trigger_date: triggerDate }
      );

      const res = response?.data?.pyResponse;

      if (res?.status === "Success") {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(res.message);
        setSliderOpen(false);
        setOverlyBlock("show-n");
        setTriggerDate(todayIST());
        
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Trigger PM  Inventory",
          status: res.status,
          path: window.location.pathname
        };
        triggerUserAction(userData);

        // Refresh the data after successful trigger
        await getMainData();
      } 
      else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(res?.message || "Failed to trigger PM  Inventory");

        // Optional audit for failures (enable if required)
        /*
        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Trigger PM  Inventory",
          status: res?.status || "Failure",
          path: window.location.pathname
        });
        */
      }

    } catch (error) {
      console.error("Error triggering PM  Inventory:", error);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("error");
      setBasicTitle(
        error?.response?.data?.message || "Failed to trigger PM  Inventory. Please try again later."
      );
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Trigger PM  Inventory",
        status: "Failed",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    } finally {
      setIsTriggering(false);
    }
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
             <div className="col-sm-12 p-0">
            <h1 className="col-sm-12" style={{color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif"}}>
              Packing Material Inventory
            </h1>
          </div>
          <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-12 row ">
              <div className="col-sm-2 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                  Date:
                </label>
                <DatePicker
                  selected={currentDate ? new Date(currentDate) : null}
                  onChange={(date) => setCurrentDate(date ? date.toISOString().split('T')[0] : '')}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  placeholderText="Select Date"
                  highlightDates={highlightedDates}
                  style={{ 
                    padding: "7px", 
                    borderRadius: "5px", 
                    border: "1px solid #d9d9d9", 
                    width: "100%", 
                    marginBottom: "15px", 
                    cursor: "pointer" 
                  }}
                />
              </div>

              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button
                  type="button"
                  onClick={setFilters}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={resetFilters}
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}
                >
                  Reset
                </button>
              </div>

              <div className="mt-4" style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  onClick={openTriggerSlider}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    height: "36px",
                    padding: "0 20px",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center"
                  }}
                >
                  Trigger PM  Inventory
                </button>
              </div>
            </div>
          </form>

          <div className="col-sm-12 p-0 pl-2">
            <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                // pagination={true}
                // paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Trigger PM  Inventory */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>
        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form
              style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={onSaveTrigger}
            >
              <div className="mb-1" style={{ display: "flex", flexDirection: "column" }}>
                <label
                  htmlFor="triggerDate"
                  style={{ fontSize: "13px", fontWeight: "400", cursor: "pointer" }}
                >
                  Date:
                </label>
                <DatePicker
                  selected={triggerDate ? new Date(triggerDate) : null}
                  onChange={(date) => setTriggerDate(date ? date.toISOString().split('T')[0] : '')}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  placeholderText="Select Date"
                  minDate={new Date("2025-09-01")}
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                  required
                />
              </div>

              {/* <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  type="submit"
                  disabled={isTriggering}
                >
                  {isTriggering ? "Processing..." : "Trigger PM  Inventory"}
                </button>
              </div> */}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: "10px" }}>
              <button
                className="btn"
                style={{
                  backgroundColor: isDateTriggered ? "#fff" : "#93385D",
                  color: isDateTriggered ? "#93385D" : "#fff",
                  border: "1px solid #93385D",
                  fontSize: "0.8rem",
                  opacity: (isTriggering || isDateTriggered) ? 0.6 : 1,
                  cursor: (isTriggering || isDateTriggered) ? "not-allowed" : "pointer",
                }}
                type="submit"
                disabled={isTriggering || isDateTriggered}
                title={isDateTriggered ? "Already triggered for this date" : ""}
              >
                {isTriggering ? "Processing..." : "Trigger PM Inventory"}
              </button>

              <button
                className="btn"
                style={{
                  backgroundColor: isDateTriggered ? "#93385D" : "#fff",
                  color: isDateTriggered ? "#fff" : "#93385D",
                  border: "1px solid #93385D",
                  fontSize: "0.8rem",
                  opacity: (isRevoking || !isDateTriggered) ? 0.6 : 1,
                  cursor: (isRevoking || !isDateTriggered) ? "not-allowed" : "pointer",
                }}
                type="button"
                onClick={onRevokeTrigger}
                disabled={isRevoking || !isDateTriggered}
                title={!isDateTriggered ? "Not triggered for this date" : ""}
              >
                {isRevoking ? "Revoking..." : "Revoke"}
              </button>
            </div>


            </form>
          </div>
        )}
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

export default PmAggregatedInventory;